<h1 class="container-heading">Service Requests List</h1>

<mat-card>
    <mat-card-content>
        <a [routerLink]="['read', 'ref', '65497540']" mat-button color="primary">Service Request #65497540</a>
    </mat-card-content>
</mat-card>